const MAX_EDIT_TIME = 30 * 60 * 1000; // 30 minutes

export default function allowEditSelfComment(createdAt: string | Date) {
  return (
    new Date(createdAt || Date.now()).getTime() + MAX_EDIT_TIME > Date.now()
  );
}
